import React from 'react'
import { Switch, Route } from 'react-router-dom'
import LogoutPageSF from '../pages/common/LogoutPageSF'
import SettingsPageSF from '../pages/common/SettingsPageSF'
// user
import UserSettingsFinPageSF from '../pages/userSettings/UserSettingsFinPageSF'
import PhoneUpdatePageSF from '../pages/userSettings/PhoneUpdatePageSF'
import UserSettingsPrjPageSF from '../pages/userSettings/UserSettingsPrjPageSF'
import NotificationsPageSF from '../pages/userSettings/NotificationsPageSF'
// account
import AccSettingsFinPageSF from '../pages/accountSettings/AccSettingsFinPageSF'
import AccSettingsPrjPageSF from '../pages/accountSettings/AccSettingsPrjPageSF'
import AccountCreatePageSF from '../pages/accountSettings/AccountCreatePageSF'
import SubscriptionPageSF from '../pages/accountSettings/SubscriptionPageSF'
import CustomerListPageSF from '../pages/accountSettings/CustomerListPageSF'
import AccountListPageSF from '../pages/accountSettings/AccountListPageSF'
import PaymentCardListPageSF from '../pages/accountSettings/PaymentCardListPageSF'
import PaymentSettingsPageSF from '../pages/accountSettings/PaymentSettingsPageSF'
import ProductItemListPageSF from '../pages/accountSettings/ProductItemListPageSF'
// accountuser
import AccountUserListPageSF from '../pages/accountUser/AccountUserListPageSF'
import AccountUserInvitePageSF from '../pages/accountUser/AccountUserInvitePageSF'
import AccountUserDetailPageSF from '../pages/accountUser/AccountUserDetailPageSF'
// project
import ProjectRoleListPageSF from '../pages/projectapp/ProjectRoleListPageSF'

const SettingsRouteUI = ({ context }) =>
  <Switch>
    <Route exact path='/settings'
      render={() =>
        <SettingsPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/fin'
      render={() =>
        <AccSettingsFinPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/prj'
      render={() =>
        <AccSettingsPrjPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/billing'
      render={() =>
        <PaymentSettingsPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/customers'
      render={() =>
        <CustomerListPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/cards'
      render={() =>
        <PaymentCardListPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/product-items'
      render={() =>
        <ProductItemListPageSF context={context} />
      }
    />

    <Route exact path='/settings/account/subscription'
      render={() =>
        <SubscriptionPageSF context={context} />
      }
    />

    <Route exact path='/settings/logout'
      render={() =>
        <LogoutPageSF context={context} />
      }
    />

    <Route exact path='/settings/members'
      render={() =>
        <AccountUserListPageSF context={context} />
      }
    />

    <Route exact path='/settings/members/invite'
      render={() =>
        <AccountUserInvitePageSF context={context} />
      }
    />

    <Route exact path='/settings/members/:userId'
      render={() =>
        <AccountUserDetailPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/fin'
      render={() =>
        <UserSettingsFinPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/prj'
      render={() =>
        <UserSettingsPrjPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/notifications'
      render={() =>
        <NotificationsPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/phone'
      render={() =>
        <PhoneUpdatePageSF context={context} />
      }
    />

    <Route exact path='/settings/user/projects'
      render={() =>
        <ProjectRoleListPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/teams'
      render={() =>
        <AccountListPageSF context={context} />
      }
    />

    <Route exact path='/settings/user/teams/create'
      render={() =>
        <AccountCreatePageSF context={context} />
      }
    />

  </Switch>
// http://localhost:3000/invite/accept/au/b0be3550-2f66-4c08-8b33-223b03fbd66f/97632e49-e737-486d-8aeb-46d2d159f23e

export default SettingsRouteUI
